<mat-card appearance="outlined" [attr.data-cy]="testIds.PARTS_LIST">
  <mat-card-content>
    <div class="flex flex-col justify-start items-stretch overflow-y-auto">
      <h1>Parts</h1>
      <ng-container *ngIf="!job; else partsList">
        <ngx-skeleton-loader count="3"></ngx-skeleton-loader>
      </ng-container>
      <ng-template #partsList>
        <app-retail-item-list parentType="workshop job" [attr.data-cy]="testIds.PARTS_ITEM_TABLE" [docketId]="job.id"
          [canEdit]="finalized === false" [canAdd]="finalized === false"></app-retail-item-list>
      </ng-template>
    </div>
  </mat-card-content>
</mat-card>